// extracted by mini-css-extract-plugin
export default {"error":"hnuuh9pjnpgMcZWIKJtP","message":"tCvPll19C1q5QvDF6ote"};